// removed by extract-text-webpack-plugin
module.exports = {"linkText":"linkText___1Pg4z"};